import { ON_SELECTED_CURRENCY_CHANGE } from '../actions.js';
import { SESSION_FETCH_SUCCESS } from '../../session/actions';

const initialState = '';

export default (state = initialState, action) => {
  // take the first currency
  if (action.type === SESSION_FETCH_SUCCESS) {
    if (action.payload.user.currencies[0]) {
      return action.payload.user.currencies[0];
    }
    return state;
  }
  else if (action.type === ON_SELECTED_CURRENCY_CHANGE) {
    return action.payload;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/modules/beta-dashboard/reducers/selected-currency.js